import CityPageTemplate from "../city-template/CityPageTemplate";
import { ashevilleConfig } from "./data";

export default function AshevillePage() {
  return <CityPageTemplate config={ashevilleConfig} />;
}